import React, { useState, createContext, useContext } from 'react'
import Api from 'utils/api'

const initSuperAdminContextPropsState = {
  superAdmin: undefined,
  setSuperAdmin: () => {},
  getSuperAdmin: async () => {},
}

const SuperAdminContext = createContext(initSuperAdminContextPropsState)

const useSuperAdmin = () => {
  return useContext(SuperAdminContext)
}

const SuperAdminProvide = ({ children }) => {
  const [superAdmin, setSuperAdmin] = useState({})

  const getSuperAdmin = async (_id) => {
    const { response } = await Api('/super_admin?_id=' + _id, 'get')
    if (response) setSuperAdmin(response.data)
    else setSuperAdmin({})
  }

  return (
    <SuperAdminContext.Provider
      value={{
        superAdmin,
        setSuperAdmin,
        getSuperAdmin,
      }}
    >
      {children}
    </SuperAdminContext.Provider>
  )
}

export { SuperAdminProvide, useSuperAdmin }
